module.exports = __webpack_public_path__ + "logo-kentico.png?471f34a16b475a57555767f1cc9fcf2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-kentico.png
// module id = 627
// module chunks = 0